import React from 'react';
import ManageLicensesPack from './components/ManageLicensesPack';
import './style.css';
const LicenseManagement = () =>
{
	return (
		<div className='flexCol respdngSM '>
			<div className='flexCol'>
				<div className='flexRow pdngXS'>
					<h2 className='mainHdngTxtSM fontWeightSM'>Manage Licenses</h2>
				</div>
				<div className='flexCol pdngXS'>
					<div className='flexCol newCard vrtclCard'>
						<ManageLicensesPack />
					</div>
				</div>
			</div>
		</div>
	);
};

export default LicenseManagement;